export default __webpack_public_path__ + "static/media/ul-logo.84e1b545.png";